import { BaseFilterListRequestModel } from "api/baseFilterListModel/BaseFilterListRequestModel";

export class CarrierListRequestModel extends BaseFilterListRequestModel {
  name?: string;
  code?: string;
  page?: number;
  limit?: number;

  constructor(data?: {
    name?: string;
    code?: string;
    page?: number;
    limit?: number;
  }) {
    super();
    this.name = data?.name;
    this.code = data?.code;
    this.page = data?.page;
    this.limit = data?.limit;
  }
}
